/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Status_Locked_TitleInputs */

const en_course_status_locked_title = /** @type {(inputs: Course_Status_Locked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locked`)
};

const ja_course_status_locked_title = /** @type {(inputs: Course_Status_Locked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロック済み`)
};

const fr_course_status_locked_title = /** @type {(inputs: Course_Status_Locked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrouillé`)
};

const de_course_status_locked_title = /** @type {(inputs: Course_Status_Locked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesperrt`)
};

/**
* | output |
* | --- |
* | "Locked" |
*
* @param {Course_Status_Locked_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_status_locked_title = /** @type {((inputs?: Course_Status_Locked_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Status_Locked_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_status_locked_title(inputs)
	if (locale === "ja") return ja_course_status_locked_title(inputs)
	if (locale === "fr") return fr_course_status_locked_title(inputs)
	return de_course_status_locked_title(inputs)
});